module.exports = __webpack_public_path__ + "static/media/Cars.99097672.png";